import * as React from "react";
import Modal from "react-bootstrap/Modal";
import ReactHtmlParser from "react-html-parser";

interface onSubmitFunction {
  (event: React.MouseEvent, reactRouteOnSuccess?): void;
}

export interface PopupOkProps {
  message: string;
  okButtonText: string;
  onPopupOK: onSubmitFunction;
  withIcon?: string;
  description?: string;
  okButtonCssContainerName?: string;
  btnCssClass?: string;
  hideModal: boolean; // 'hide' instead of 'show' to be compatible with the current implementation within forms and other components
}

export const PopupOk = (props: PopupOkProps) => {
  function handleClose() {
    props.hideModal = true;
  }

  return (
    <Modal
      className={
        "form__popup form__popup-ok " +
        (props.okButtonCssContainerName ? props.okButtonCssContainerName : "")
      }
      centered
      show={!props.hideModal}
      onHide={() => {
        handleClose();
      }}
    >
      <Modal.Header className="form__popup-header">
        <Modal.Title className="form__popup-ok-icon-container">
          <span
            className={
              "icon " +
              (props.withIcon
                ? "form__popup-default-ok-icon " + props.withIcon
                : "form__popup-ok-icon rounded-circle icon-checkmark")
            }
          ></span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="form__popup-content form__popup-ok-text-container">
        <div className="form__popup-content-text form__popup-ok-text">
          {ReactHtmlParser(props.message)}
        </div>
        {props.description && (
          <div className="form__popup-content-decription">
            {ReactHtmlParser(props.description)}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer className="form__popup-buttons">
        <span
          onClick={(e) => props.onPopupOK(e)}
          className={
            "btn " + (props.btnCssClass ? props.btnCssClass : "btn-success")
          }
        >
          {props.okButtonText}
        </span>
      </Modal.Footer>
    </Modal>
  );
};
